import { BUTTON_FONT } from 'components/landing/constants';
import ButtonContainer from 'core/button-container';
import dynamic from 'next/dynamic';
import { PinkButton } from 'core/buttons/buttons';
import propTypes from 'prop-types';
import Spacer from 'core/spacer';
import styles from 'styles/ContentBanner.module.scss';
import Text from 'core/text';
import Title from 'core/title';

const CecaES = dynamic(() => import('components/blog/content-banner/horizonal-logo-es'));
const CecaPT = dynamic(() => import('components/blog/content-banner/horizonal-logo-pt'));

const ContentBanner = ({ config, bannerType = 'body', culture = 'es-ar' }) => {
    if (config.text === undefined || config.text.title === undefined) {
        return null;
    };

    return (
        <div className={`${styles.container} ${bannerType === 'lateral' && styles.containerMargin}`}>
            <div className={styles.topMargin} />
            <div className={bannerType === 'body' ? styles.containerBannerBody : styles.containerBannerLateral}>
                {config.config.with_logo && (
                    culture === 'pt-br' ? <CecaPT /> : <CecaES />
                )}
                {config.text.title !== undefined && <Title align titleType="subtitle" content={config.text.title} />}
                <ButtonContainer>
                    <PinkButton
                        label={config.text.button.label}
                        href={config.text.button.href}
                        propsButton={BUTTON_FONT}
                        compact
                        align
                        alignText="center"
                    />
                </ButtonContainer>
                <Spacer />
                {config.text.subtitle !== undefined && <Text align content={config.text.subtitle} />}
            </div>
        </div>
    );
};

ContentBanner.propTypes = {
    config: propTypes.object,
    bannerType: propTypes.string,
    culture: propTypes.string
};

export default ContentBanner;
